import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { SuperDirectivesModule } from './directives/@directives.module';
import { SuperPipesModule } from './pipes/@pipes.module';
import { SuperCodeComponent } from './super-code.component';
import { SuperCodeService } from './super-code.service';

@NgModule({
  declarations: [
    SuperCodeComponent, 
    FormErrorComponent,
  ],
  imports: [
    //Native Library
    ReactiveFormsModule, 
    CommonModule,
    //SuperCode Library
    SuperPipesModule,
    SuperDirectivesModule, 
    FormsModule, 
  ],
  exports: [
    FormErrorComponent,
    SuperPipesModule, 
    SuperDirectivesModule,
  ], 
  providers : [
    SuperCodeService
  ]
})
export class SuperCodeModule { }
